module.exports = {"heading":"工程實績","filter":{"type":"工程種類","client":"單位類別","during":"日期範圍"},"detail":{"address":"地址","amount":"金額","client":"客戶類別","during":"工程期間","intro":"介紹","organizer":"案件主","type":"種類"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/CasePage/locale/zh.json
// module id = 890
// module chunks = 0